import { Button } from "antd";
import styled, { createGlobalStyle } from "styled-components";

export const StyledSheet = styled.section<{ $open: boolean }>`
    width: 100%;
    display: grid;
    grid-template-rows: ${({ $open }) => ($open ? "1fr" : "0fr")};
    transition: grid-template-rows 220ms ease;
    pointer-events: ${({ $open }) => ($open ? "auto" : "none")};
    background: ${({ theme }) => theme.primaryBackground};
`;

export const StyledViewport = styled.div`
    min-height: 0;
    overflow: hidden;
`;

export const StyledBody = styled.div`
    position: relative;
    padding: 35px 16px 0;

    &::before {
        content: "";
        position: absolute;
        width: 150px;
        height: 4px;
        border-radius: 5px;
        background: ${({ theme }) => theme.disabledTypographyColor};
        top: 16px;
        left: 50%;
        transform: translateX(-50%);
    }
`;

export const StyledActionsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 16px;
    padding-top: 16px;
    padding-bottom: 40px;
`;

export const StyledButton = styled(Button)`
    background: transparent;
    width: 24px !important;
    padding: 2px !important;
    height: 24px;
    border: none;
    color: ${({ theme }) => theme.secondaryTypographyColor};

    svg {
        font-size: 18px;
    }
`;

export const StyledInfoButton = styled(StyledButton)`
    position: absolute;
    left: 12px;
    top: 10px;
`;

export const GlobalBottomSheetStyle = createGlobalStyle`
.message-select-popup {
  border-radius: 0;
  transform: translateY(25px) !important;
}
`;
